import React, { useEffect } from "react";
import Modal from "..";
import {
    MainContainer,
    Header,
    HorizontalLine,
    ContentContainer,
} from "../ModalStyledComponents";
import {
    Reservation as ReservationModel,
    RestrictedReservation as RestrictedReservationModel,
} from "../../calendar/model";
import Reservation from "./Reservation";
import RestrictedReservation from "./RestrictedReservation";
import { useTranslation } from "react-i18next";

interface Props {
    reservations: ReservationModel[];
    restrictedReservations: RestrictedReservationModel[];
    open: boolean;
    onClose: () => void;
}

const ReservationModal = ({
    reservations,
    restrictedReservations,
    open,
    onClose,
}: Props) => {
    const { t } = useTranslation();
    // Close if all cancelled
    useEffect(() => {
        if (reservations.length + restrictedReservations.length === 0) {
            onClose();
        }
    }, [onClose, reservations.length, restrictedReservations.length]);

    return (
        <Modal open={open} onClose={onClose}>
            <MainContainer>
                <Header>
                    <h3>{t('reservations')}</h3>
                </Header>
                <HorizontalLine />
                <ContentContainer>
                    {reservations.map((reservation) => (
                        <Reservation
                            key={reservation.id}
                            reservation={reservation}
                        />
                    ))}
                    {restrictedReservations.map((reservation) => (
                        <RestrictedReservation
                            key={reservation.datetime}
                            reservation={reservation}
                        />
                    ))}
                </ContentContainer>
            </MainContainer>
        </Modal>
    );
};

export default ReservationModal;
